import React, {useState, useEffect}from 'react'
import {motion } from "framer-motion"
import "./About.scss"
import { Images } from '../../constants'

import { urlFor, client } from '../../client'

import { AppWrap , MotionWrap } from '../../wrapper'

// const Abouts = [
//   {title:'Blockchain Development', description:'Ethereum and EVM chains ', imgUrl:Images.about01},
//   {title:'FrontEnd Development', description:'Im a good Developer ', imgUrl:Images.about02},
//   {title:'Crypto Analyst', description:'Analyze and monitor crypto market ', imgUrl:Images.about03},
//   // {title:'Blockchain Development', description:'Im a good Developer ', imgUrl:''}
// ]

const About = () => {
  const [Abouts, setAbouts] = useState([])


  useEffect(()=>{
    const query = '*[_type=="abouts"]'
                  // '*[_type == "post"]'

     client.fetch(query)
    .then((data)=>{
      setAbouts(data)
    })
  },[])
  return (
    <>
      <h2 className='head-text'>i know <span>a good contract </span><br/> must have a  <span>good test</span></h2>

      <div className='app__profiles'>
        {Abouts.map((about,index)=>(
          <motion.div
          whileInView={{opacity:1}}
          whileHover={{scale:1.1}}
          transition={{duration:0.6, type:'tween'}}
          className='app__profile-item'
          key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title}/>
            <h2 className='bold-text' style={{marginTop:20}}> {about.title}</h2>
            <p className='p-text' style={{marginTop:10}}> {about.description}</p>


          </motion.div>
        ))}
      </div>
    </>
  )
}

export default  AppWrap(
  MotionWrap(About, 'app__about'),
   'about',
   'app__whitebg'
   )